import React from 'react'
import PackingItemHeader from './PackingItemTable/PackingItemHeader'
import PackingItemRow from './PackingItemTable/PackingItemRow'

function PackingItemTable(props) {
    const {listPackingItem, loading, setType, setBrand, setUser} = props
    
    return (
        <div className="PackingItemTable">
            <table className="table table-borderless table-striped">
                <PackingItemHeader/>
                <tbody className="PackingItemRow">
                {
                    !!listPackingItem && listPackingItem.map((item, i) => {
                        const {products, ...barcode} = item
                        item = {
                            ...products,
                            barcode,
                        }
                        const key = `${item._id}_${i}`

                        return <PackingItemRow
                            key={key}
                            index={i}
                            item={item}
                            setType={setType}
                            setBrand={setBrand}
                            setUser={setUser}
                        />
                    })
                }
                {
                    !loading && (!listPackingItem || listPackingItem.length === 0) &&
                    <tr>
                        <td colSpan={7}>
                            No result
                        </td>
                    </tr>
                }
                </tbody>
            </table>
        </div>
    )
}

export default PackingItemTable
